import React from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDashboard, faList } from "@fortawesome/free-solid-svg-icons";
function NfsmSidebar() {
    return (
        <>
   <aside id="myDIV" className="sidebar mapsidebar">
         <ul class="sidebar-nav" id="sidebar-nav">
         
         <li class="nav-item">
         <NavLink className="nav-link collapsed" to="/nfsmscheme"><i><FontAwesomeIcon icon={faList}/> </i><span> Crop Wise Report</span></NavLink>
            </li>
         <li class="nav-item">
         <NavLink className="nav-link collapsed" to="/NFSMCFLDWiseReport"><i><FontAwesomeIcon icon={faList}/> </i><span> CFLD Wise Area Covered</span></NavLink></li>
         <li class="nav-item">
         <NavLink className="nav-link collapsed" to="/NFSMFarmersOutcomesUploadedReport"><i><FontAwesomeIcon icon={faList}/> </i><span> Farmers Outcomes Uploaded</span></NavLink></li>
         <li class="nav-item d-none">
            <NavLink className="nav-link collapsed" to="/schemereports"><i><FontAwesomeIcon icon={faDashboard}/> </i><span> All Schemes</span></NavLink></li>
        </ul>
            </aside>
        </>
              

 );
}           
export default NfsmSidebar